// Quantity maths shared by the Stock Transfer screen's "Split Equally" button
// and the multi-store submit that actually sends the split.

// Divide `total` into `storeCount` whole-number shares that add back up to
// exactly `total` — no unit is lost to rounding. The remainder is handed to
// the LAST stores, so the shares only ever rise across the list: 43 over 2
// stores is [21, 22], 43 over 3 is [14, 14, 15].
//
// Quantities here are whole units (the batch quantity inputs are integers), so
// a fractional total is floored before splitting rather than spread as
// fractions across stores.
export const splitQuantityAcrossStores = (total, storeCount) => {
  const count = Math.max(0, Math.floor(Number(storeCount) || 0));
  if (count === 0) return [];
  const amount = Math.max(0, Math.floor(Number(total) || 0));
  const base = Math.floor(amount / count);
  // How many stores get one extra unit — always fewer than `count`, so the
  // biggest share is never more than one unit above the smallest.
  const remainder = amount - base * count;
  return Array.from(
    { length: count },
    (_, index) => base + (index >= count - remainder ? 1 : 0)
  );
};

// The share store `storeIndex` of `storeCount` receives out of `total`.
export const getStoreShare = (total, storeCount, storeIndex) =>
  splitQuantityAcrossStores(total, storeCount)[storeIndex] ?? 0;
